import ExportsPage from 'components/Exports';
import { FC, useState } from 'react';
import { connect } from 'react-redux';
import { setExportColumns, setTags } from 'store/actions/admin/menteeLists';
import { StoreState } from 'store/reducers';
import Tags from 'types/Tags';
import { Action } from 'types/typeguards/reducerActions';
import { apiURL } from 'utils/apiURL';
import { getIsMenteeStatus } from 'utils/menteeTags';
import privateAPI from 'utils/privateAxiosInstance';
import getTagsQueryParams from 'utils/tagQueryParam';
import { TagColumnNames } from '.';

export const exportColumnNames = [
  'id',
  'Prénom',
  'Nom',
  'Adresse email',
  'Numéro de téléphone',
  'Chargé(e) de mentorat',
  "Date d'inscription",
  'Adresse',
  'Ville',
  'Pays',
  'Région',
  'Code postal',
  'Statut du mentorat',
  "Recherche d'emploi",
  'Carrière',
  'Études',
  'Entreprenariat',
  'Partage',
  'Domaines de compétence',
  'Formation effectuée',
  'Plus haut niveau de diplôme',
  'Formation en accord avec le projet ?',
  'État de la formation',
  'Formation correspondant au projet',
  'Niveau de diplôme visé',
  'Mode de vie',
  'Passe temps',
  'État du service civique',
  'Date du dernier entretien',
  'Accord pour un recontact INJEP',
] as const;
export type ExportColumn = typeof exportColumnNames[number];
export type ExportColumns = Record<ExportColumn, boolean>;
export const defaultExportColumns: ExportColumns = {
  id: false,
  Prénom: false,
  Nom: false,
  'Adresse email': false,
  'Numéro de téléphone': false,
  'Chargé(e) de mentorat': false,
  "Date d'inscription": false,
  Adresse: false,
  Ville: false,
  Pays: false,
  Région: false,
  'Code postal': false,
  'Statut du mentorat': false,
  "Recherche d'emploi": false,
  Carrière: false,
  Études: false,
  Entreprenariat: false,
  Partage: false,
  'Domaines de compétence': false,
  'Formation effectuée': false,
  'Plus haut niveau de diplôme': false,
  'Formation en accord avec le projet ?': false,
  'État de la formation': false,
  'Formation correspondant au projet': false,
  'Niveau de diplôme visé': false,
  'Mode de vie': false,
  'Passe temps': false,
  'État du service civique': false,
  'Date du dernier entretien': false,
  'Accord pour un recontact INJEP': false,
};

type Props = {
  tags: Tags<TagColumnNames>;
  setTags: (tag: Tags<TagColumnNames>) => void;
  search: string;
  exportColumns: ExportColumns;
  setExportColumns: (exportColumns: ExportColumns) => void;
};
const Export: FC<Props> = ({
  tags,
  // setTags,
  search,
  exportColumns,
  setExportColumns,
}) => {
  // const { data: referees } = useSWR<MentorshipReferee[]>('/mentorship-referee');

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const handleDownload = () => {
    setLoading(true);
    setError('');
    privateAPI
      .get(
        `${apiURL}/exports/mentees?param=e${search ? `&search=${search}` : ''}\
${Object.entries(exportColumns)
  .map(([key, value]) => {
    return value ? `&columns=${key}` : '';
  })
  .join('')}\
		${
      tags.status[0]
        ? tags.status
            .map((tag) =>
              getIsMenteeStatus(tag)
                ? `&menteeTags=${tag}`
                : `&mentorshipTags=${tag}`,
            )
            .join('')
        : ''
    }\
		${getTagsQueryParams<TagColumnNames>(tags, [
      'referee',
      'jobSearch',
      'careerPlan',
      'studies',
      'entrepreneurship',
      'expertiseFields',
      'completedFormation',
      'validatedDiploma',
      'formationMatchingProject',
      'formationState',
      'intendedFormation',
      'intendedDiploma',
      'consideration',
      'hobby',
      'volunteerState',
    ])}`,
        { responseType: 'blob' },
      )
      .then((res) => {
        try {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'mentores.csv');
          document.body.appendChild(link);
          link.click();
        } catch {
        }
      })
      .catch(() => {
        try {
          window.scrollTo({ top: 0 });
        } catch {
        }
        setError('Une erreur est survenue.');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <ExportsPage
      backTo="/admin/mentoring/mentees"
      pageTitle="Exporter la liste"
      // tagList={[
      //   {
      //     columnName: 'referee',
      //     columnTitle: 'Chargé de mentorat',
      //     tags:
      //       referees?.map((referee) => {
      //         return {
      //           name: referee.name || '',
      //           label: `(Chargé) ${referee.name}`,
      //           labelComponent: referee.name || '',
      //         };
      //       }) || [],
      //   },
      //   {
      //     columnName: 'status',
      //     columnTitle: 'Statut du mentorat',
      //     tags: menteeTags.map((tag) => {
      //       const isMenteeStatus = getIsMenteeStatus(tag);
      //       return {
      //         name: tag,
      //         label: isMenteeStatus
      //           ? MENTEE_STATUS[tag]
      //           : MENTORSHIP_STATUS[tag],
      //         labelComponent: (
      //           <MenteeStatusChip
      //             status={
      //               isMenteeStatus
      //                 ? (tag as MenteeStatusValues)
      //                 : 'MENTORSHIP_ACTIVE'
      //             }
      //             mentorshipStatus={
      //               isMenteeStatus ? 'ONGOING' : (tag as MentorshipStatusValues)
      //             }
      //           />
      //         ),
      //       };
      //     }),
      //   },
      //   getJobSearchColumn('mentee'),
      //   getCareerPlanColumn('mentee'),
      //   getStudiesColumn('mentee'),
      //   getEntrepreneurshipColumn('mentee'),
      //   expertiseFieldsColumn,
      //   completedFormationColumn,
      //   validatedDiplomaColumn,
      //   formationMatchingProjectColumn,
      //   formationStateColumn,
      //   intendedFormationColumn,
      //   intendedDiplomaColumn,
      //   considerationColumn,
      //   hobbyColumn,
      //   volunteerStateColumn,
      // ]}
      // tags={tags}
      // setTags={setTags}
      columnList={exportColumnNames}
      columns={exportColumns}
      setColumns={setExportColumns}
      onDowload={handleDownload}
      loading={loading}
      error={error}
    />
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    tags: state.admin.menteeLists.main.tags,
    search: state.admin.menteeLists.main.search,
    exportColumns: state.admin.menteeLists.main.exportColumns,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setTags: (tags: Tags<TagColumnNames>) =>
      dispatch(setTags<TagColumnNames>('main', tags)),
    setExportColumns: (exportColumns: ExportColumns) =>
      dispatch(setExportColumns('main', exportColumns)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Export);
